export interface AddItemPayload {
  id?: string;
  nome: string;
  posologia?: string;
  indicacoes?: string;
  quantidade?: number;
  fabricante?: string;
  preco?: number;
  descricao?: string;
  tipo?: string;
  custom_categoria?: string;
}

export interface MedikeiPrescriptionItem {
  id?: string;
  tipo?: 'MEDICAMENTO' | 'EXAME' | 'ATESTADO' | string;
  nome?: string;
  presentation?: string;
  concentration?: string;
  dosagem?: string;
  dose?: string;
  frequency?: string;
  duration?: string;
  posologia?: string;
  quantidade?: number;
  unidade?: string;
  fabricante?: string;
  preco?: number;
  descricao?: string;
  observacoes?: string;
  indicacoes?: string;
}

function isExamOrAttestation(item: MedikeiPrescriptionItem): boolean {
  return item.tipo === 'EXAME' || item.tipo === 'ATESTADO';
}

function composePosologia(item: MedikeiPrescriptionItem): string | undefined {
  if (item.posologia?.trim()) {
    return item.posologia.trim();
  }

  const parts = [
    item.dose?.trim(),
    item.frequency?.trim(),
    item.duration?.trim() ? `por ${item.duration.trim()}` : undefined,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' ') : undefined;
}

export function buildAddItemPayload(item: MedikeiPrescriptionItem): AddItemPayload | null {
  if (isExamOrAttestation(item)) {
    const nome = item.descricao?.trim() || item.nome?.trim() || item.indicacoes?.trim() || '';
    if (!nome) {
      return null;
    }

    const payload: AddItemPayload = { nome };
    const indicacoes = item.indicacoes?.trim();
    if (indicacoes && indicacoes !== nome) {
      payload.posologia = indicacoes;
    }
    return payload;
  }

  const nomeParts = [
    item.nome?.trim(),
    item.presentation?.trim(),
    item.dosagem?.trim() || item.concentration?.trim(),
  ].filter(Boolean);

  if (nomeParts.length === 0) {
    return null;
  }

  let nome = nomeParts.join(' ');
  if (item.unidade?.trim()) {
    nome = `${nome} (${item.unidade.trim()})`;
  }

  const payload: AddItemPayload = { nome };

  const posologia = composePosologia(item);
  if (posologia) {
    payload.posologia = posologia;
  }

  if (item.quantidade !== undefined && Number.isFinite(item.quantidade)) {
    payload.quantidade = item.quantidade;
  }

  if (item.fabricante?.trim()) {
    payload.fabricante = item.fabricante.trim();
  }

  if (item.preco !== undefined && Number.isFinite(item.preco)) {
    payload.preco = item.preco;
  }

  const descricao = item.descricao?.trim() || item.observacoes?.trim();
  if (descricao) {
    payload.descricao = descricao;
  }

  return payload;
}

export function buildAddItemsPayload(items: MedikeiPrescriptionItem[]): AddItemPayload[] {
  return items
    .map(buildAddItemPayload)
    .filter((payload): payload is AddItemPayload => payload !== null);
}
